<template>
  <div class="user-list">
    <div class="search-bar flex">
      <div class="left">
        <el-input
          v-model="searchParam.keyword_search"
          placeholder="输入要搜索的内容"
          clearable
          @clear="getList"
        ></el-input>
        <el-select v-model="searchParam.type" placeholder="题型" clearable @clear="getList">
          <el-option label="单选" value="1"></el-option>
          <el-option label="多选" value="2"></el-option>
          <el-option label="实操" value="3"></el-option>
        </el-select>
        <el-select v-model="searchParam.subject_tip_uuid" placeholder="请选择" clearable @change="getList">
          <el-option v-for="item in subjectTipList" :key="item.uuid" :label="item.name" :value="item.uuid"> </el-option>
        </el-select>

        <el-button type="primary" @click="getList('clear')">查询</el-button>
      </div>
      <div class="right">
        <el-button v-if="isteacher" @click="toDetail()">新建题目</el-button>
        <el-button @click="handleDownTemp">下载模板</el-button>
        <el-button class="m-btn">
          <span>导入</span>
          <div class="m-cover">
            <input type="file" @change="handleImport" />
          </div>
        </el-button>
      </div>
    </div>
    <div class="table">
      <el-table v-loading="loading" :data="tableData" border style="width: 100%">
        <el-table-column type="index" label="序号" width="120px"> </el-table-column>

        <el-table-column prop="type" label="题型" width="120px">
          <template slot-scope="scope">
            <span v-if="scope.row.type === 1">单选</span>
            <span v-if="scope.row.type === 2">多选</span>
            <span v-if="scope.row.type === 3">实操</span>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="问题"> </el-table-column>
        <el-table-column prop="subject_tips" label="科目" width="120px">
          <template slot-scope="scope">
            {{ scope.row.subject_tips.map((v) => v.name).join(",") }}
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间"> </el-table-column>
        <el-table-column label="操作" fixed="right" width="280">
          <template slot-scope="scope">
            <el-button class="mid-blue" @click="toDetail(scope.row)">编辑</el-button>

            <el-button class="mid-red" @click="deleteItem(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          :current-page="page_index"
          :page-sizes="[10, 20, 60, 100]"
          :page-size="page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { subjectList, delSubject, importSubject, subjectTipList } from "@/api/edu.js";
import { mixin } from "@/mixins/pagination.js";
import Utils from "@/jslibs/utils";

export default {
  mixins: [mixin],
  data() {
    return {
      loading: false,
      teacherList: [],
      searchParam: {
        keyword_search: "",
        status: "2",
        start_time: "",
        end_time: "",
        subject_tip_uuid: "",
      },
      tableData: [],
      page_size: 10,
      subjectTipList: [],
    };
  },
  computed: {
    isteacher() {
      const g = Utils.getCookie("X-Access-Group");
      return g != 927 && g != 952;
    },
  },
  mounted() {
    this.getList();
    this.getSubjectTipList();
  },
  methods: {
    // 获取科目列表
    async getSubjectTipList() {
      const res = await subjectTipList({ page_index: 1, page_size: 999 });
      this.subjectTipList = res.data;
    },
    toAdd(row) {
      console.log(row);
      this.$router.push({
        path: "/offline-detail",
        query: row,
      });
    },
    toDetail(row) {
      console.log(row);
      this.$router.push({
        path: "/topic-add",
        query: { ...row, paper_uuid: this.$route.query.uuid },
      });
    },

    setTop(row) {},
    xiajia(row) {},
    deleteItem(row) {
      this.$confirm("确定要删除该课程吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delSubject(row.uuid).then((res) => {
            if (res) {
              this.$message.success("成功");
              this.getList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    async getList(type) {
      console.log(type, "=====");
      if (type == "clear") {
        this.page_index = 1;
      }
      const param = {
        // paper_uuid: this.$route.query.uuid,
        page_index: this.page_index,
        page_size: this.page_size,
        // paper_uuid: this.$route.query.paper_uuid,
        ...this.searchParam,
      };
      this.loading = true;
      const res = await subjectList(param);
      this.loading = false;
      if (res.data instanceof Array) {
        this.tableData = res.data;
        this.total = res.total;
      }
    },
    handleDownTemp() {
      window.open(`/题库导入模板.xlsx`);
    },
    async handleImport(e) {
      const file = e.target.files[0];
      const formData = new FormData();
      formData.append("file", file);
      const res = await importSubject(formData);
      if (!res.result) return this.$message.error("导入失败");
      this.$message.success("导入成功");
      this.getList();
    },
  },
};
</script>

<style scoped="scoped">
.user-list {
  background: white;
  padding: 10px;
  box-sizing: border-box;
}

.m-btn {
  position: relative;
  .m-cover {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    opacity: 0;
  }
}
</style>
